<template>
  <div class="home">
    <!-- Header -->
    <div class="container p-0" id="top">
      <img src="@/assets/img/header-scholarship.png" alt="header" width="100%" />
    </div>
    <!-- Header -->

    <!-- Body -->
    <div class="container">
      <div class="row bg_ffffff">
        <div class="col-12 col-sm-12 padding_30 padding_top_20">
          <div class="csfont_Signika_Lite color_6d6e71 text-left font-size-16">
            <form @submit.prevent="Submit">
              <div class="row px-3">
                <!-- *****************ผู้สมัครขอทุน****************** -->
                <div class="col-12 col-sm-8 col-md-9 mt-2"></div>
                <div class="col-12 col-sm-4 col-md-3 mt-2" id="profile">
                  <img :src="FileProfileURL" class="w-100 mb-3" />
                  <center>
                    <label
                      for="Profile"
                      :class="previewMode == true ? 'd-none' : ''"
                      class="custom-file-upload btn btn-app"
                    >
                      อัปโหลดรูปถ่าย
                    </label>
                    <input
                      id="Profile"
                      type="file"
                      @change="FileUploadProfile"
                      accept="image/*"
                    />
                  </center>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <h5 class="text-dark text-underline">ผู้สมัครขอทุน</h5>
                </div>
                <div class="col-12 col-sm-12">
                  <span class="pl-3 text-dark"> ข้อมูลส่วนตัว </span>
                  <div class="row">
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-3 col-md-3">
                      <span class="pl-2">คำนำหน้าชื่อ:</span>
                      <select
                        v-if="!previewMode"
                        style="padding: 4px; padding-left: 10px"
                        class="w-100 ml-1"
                        :class="TitleSelect == true ? 'text-sec' : ''"
                        required
                        v-model="ScholarshipApplicant.Profile.Title"
                      >
                        <option selected disabled :value="null">---</option>
                        <option value="นาย">นาย</option>
                        <option value="นางสาว">นางสาว</option>
                      </select>
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.Title }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-9 col-md-9">
                      <div class="row">
                        <div class="col-12 col-sm-6 col-md-6">
                          <span class="pl-2">ชื่อ-สกุล:</span>
                          <input
                            type="text"
                            class="ml-1 w-100"
                            v-if="!previewMode"
                            required
                            v-model="ScholarshipApplicant.Profile.NameTH"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.NameTH }}
                          </p>
                        </div>
                        <!-- *************************************************** -->
                        <div class="col-12 col-sm-6 col-md-6">
                          <span class="pl-2">นามสกุล:</span>
                          <input
                            type="text"
                            class="ml-1 w-100"
                            v-if="!previewMode"
                            required
                            v-model="ScholarshipApplicant.Profile.LastnameTH"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.LastnameTH }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 mt-1">
                      <span class="pl-2">ภาษาอังกฤษ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        v-if="!previewMode"
                        required
                        v-model="ScholarshipApplicant.Profile.NameEN"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.NameEN }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 mt-1">
                      <span class="pl-2">อีเมล:</span>
                      <input
                        type="email"
                        class="ml-1 w-100"
                        v-if="!previewMode"
                        required
                        v-model="ScholarshipApplicant.Profile.Email"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.Email }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 mt-1">
                      <span class="pl-2">กำลังศึกษาอยู่สถาบัน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        v-if="!previewMode"
                        required
                        v-model="ScholarshipApplicant.Profile.StudyingAtTheInstitute"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.StudyingAtTheInstitute }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 mt-1">
                      <span class="pl-2">คณะ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        v-if="!previewMode"
                        required
                        v-model="ScholarshipApplicant.Profile.Faculty"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.Faculty }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 mt-1">
                      <span class="pl-2">สาขาวิชา:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        v-if="!previewMode"
                        required
                        v-model="ScholarshipApplicant.Profile.Major"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.Major }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-6 col-sm-6 mt-1">
                      <span class="pl-2">รหัส:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        v-if="!previewMode"
                        required
                        v-model="ScholarshipApplicant.Profile.StudentCode"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.StudentCode }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-6 col-sm-4 mt-1">
                      <span class="pl-2">ชั้นปี:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Profile.YearClass"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.YearClass }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-4 mt-1">
                      <span class="pl-2">คะแนนเฉลี่ย (ล่าสุด):</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Profile.AverageScoreNow"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.AverageScoreNow }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-4 mt-1">
                      <span class="pl-2">วัน/เดือน/ปี เกิด:</span>
                      <input
                        v-if="!previewMode"
                        type="date"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Profile.DateOfBirth"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.DateOfBirth }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 mt-1">
                      <span class="pl-2">สถานที่เกิด:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Profile.PlaceOfBirth"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.PlaceOfBirth }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 mt-1">
                      <span class="pl-2">ศาสนา:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Profile.Religion"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{ ScholarshipApplicant.Profile.Religion }}
                      </p>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-12 mt-4">
                      <span class="pl-3 text-dark">
                        ภูมิลำเนาเดิม (ที่อยู่ตามทะเบียนบ้าน)
                      </span>
                      <div class="row">
                        <div class="col-6 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">บ้านเลขที่:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.Number"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.Number }}
                          </p>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">หมู่ที่:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.Moo"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.Moo }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">ถนน:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.Road"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.Road }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">ตำบล:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.Tambon"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.Tambon }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">อำเภอ:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.District"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.District }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">จังหวัด:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.Province"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.Province }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">รหัสไปรษณีย์:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.Postcode"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.Postcode }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">โทรศัพท์:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.Phone"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.Phone }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">โทรศัพท์มือถือ:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.Domicile.Mobile"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.Domicile.Mobile }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-12 mt-4">
                      <span class="pl-3 text-dark">
                        ที่อยู่ปัจจุบัน (ติดต่อได้สะดวก)
                      </span>
                      <div class="row">
                        <div class="col-6 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">บ้านเลขที่:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.Number"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.Number }}
                          </p>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">หมู่ที่:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.Moo"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.Moo }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">ถนน:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.Road"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.Road }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">ตำบล:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.Tambon"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.Tambon }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">อำเภอ:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.District"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.District }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">จังหวัด:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.Province"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.Province }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">รหัสไปรษณีย์:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.Postcode"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.Postcode }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">โทรศัพท์:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.Phone"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.Phone }}
                          </p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-1">
                          <span class="pl-2">โทรศัพท์มือถือ:</span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100"
                            required
                            v-model="ScholarshipApplicant.Profile.CurrentAddress.Mobile"
                            placeholder="---"
                            style="padding-left: 10px; padding: 2.5px"
                          />
                          <p v-if="previewMode" class="pl-2">
                            {{ ScholarshipApplicant.Profile.CurrentAddress.Mobile }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- *************************************************** -->
                  </div>
                </div>
                <!-- *****************ผู้สมัครขอทุน****************** -->
                <!-- *****************ประวัติการศึกษาโดยย่อ*********************** -->
                <div class="col-12 col-sm-12 mt-4">
                  <h5 class="text-dark text-underline">ประวัติการศึกษาโดยย่อ</h5>
                </div>
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row">
                    <!-- ประถมศึกษา -->
                    <div class="col-6 col-sm-4 col-md-4">
                      <p class="text-left">ประถมศึกษา</p>
                    </div>
                    <div class="col-6 col-sm-4">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.BriefEducationalBackground.PrimarySchool
                            .Name
                        "
                        placeholder="--- โรงเรียน ---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.BriefEducationalBackground.PrimarySchool
                            .Name
                        }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-4 d-block d-sm-none"></div>
                    <div class="col-6 col-sm-4">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.BriefEducationalBackground.PrimarySchool
                            .Province
                        "
                        placeholder="--- จังหวัด ---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.BriefEducationalBackground.PrimarySchool
                            .Province
                        }}
                      </p>
                    </div>
                    <!-- ประถมศึกษา -->
                    <div class="col-12 col-sm-12 d-block d-sm-none mt-4"></div>
                    <!-- มัธยมศึกษาตอนต้น -->
                    <div class="col-6 col-sm-4 col-md-4">
                      <p class="text-left">มัธยมศึกษาตอนต้น</p>
                    </div>
                    <div class="col-6 col-sm-4">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.BriefEducationalBackground.JuniorHighSchool
                            .Name
                        "
                        placeholder="--- โรงเรียน ---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.BriefEducationalBackground.JuniorHighSchool
                            .Name
                        }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-4 d-block d-sm-none"></div>
                    <div class="col-6 col-sm-4">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.BriefEducationalBackground.JuniorHighSchool
                            .Province
                        "
                        placeholder="--- จังหวัด ---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.BriefEducationalBackground.JuniorHighSchool
                            .Province
                        }}
                      </p>
                    </div>
                    <!-- มัธยมศึกษาตอนต้น -->
                    <div class="col-12 col-sm-12 d-block d-sm-none mt-4"></div>
                    <!-- มัธยมศึกษาตอนปลาย -->
                    <div class="col-6 col-sm-4">
                      <p class="text-left">มัธยมศึกษาตอนปลาย</p>
                    </div>
                    <div class="col-6 col-sm-4">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.BriefEducationalBackground.HighSchool.Name
                        "
                        placeholder="--- โรงเรียน ---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.BriefEducationalBackground.HighSchool.Name
                        }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-4 d-block d-sm-none"></div>
                    <div class="col-6 col-sm-4">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.BriefEducationalBackground.HighSchool
                            .Province
                        "
                        placeholder="--- จังหวัด ---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.BriefEducationalBackground.HighSchool
                            .Province
                        }}
                      </p>
                    </div>
                    <!-- มัธยมศึกษาตอนปลาย -->
                    <div class="col-6 col-sm-4 mt-0">
                      <span class="text-left">เกรดเฉลี่ยสะสม (ม.ปลาย)</span>
                    </div>
                    <div class="col-6 col-sm-4 mt-0">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.BriefEducationalBackground.CumulativeGPA
                        "
                        placeholder="--- เกรดเฉลี่ยสะสม ---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.BriefEducationalBackground.CumulativeGPA
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- *****************ประวัติการศึกษาโดยย่อ*********************** -->
                <!-- ******************สถานภาพครอบครัวของผู้ขอทุน**************** -->
                <div class="col-12 col-sm-12 mt-4">
                  <h5 class="text-dark text-underline">สถานภาพครอบครัวของผู้ขอทุน</h5>
                </div>
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row">
                    <!-- ****************** ข้อมูลบิดา **************** -->
                    <div class="col-6 col-sm-6 col-md-4">
                      <span class="pl-2">ชื่อบิดา:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Name
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Name
                        }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4">
                      <span class="pl-2">อายุ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Age
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Age
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 mt-3 pl-3">
                      <input
                        v-if="!previewMode"
                        class="form-check-input"
                        type="radio"
                        name="FatherAlive"
                        :value="1"
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Alive
                        "
                      />
                      <label
                        class="form-check-label pl-1"
                        for="inlineRadio1"
                        v-if="!previewMode"
                      >
                        ยังมีชีวิตอยู่
                      </label>
                      <p
                        class="mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Alive == 1
                            ? ''
                            : 'd-none'
                        "
                      >
                        สถานะภาพ:
                        <br />
                        ยังมีชีวิตอยู่
                      </p>
                      <br />
                      <input
                        v-if="!previewMode"
                        class="form-check-input"
                        type="radio"
                        name="FatherAlive"
                        :value="0"
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Alive
                        "
                      />

                      <label
                        class="form-check-label pl-1"
                        for="inlineRadio2"
                        v-if="!previewMode"
                      >
                        ถึงแก่กรรม
                      </label>
                      <p
                        class="mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Alive == 0
                            ? ''
                            : 'd-none'
                        "
                      >
                        สถานะภาพ:
                        <br />
                        ถึงแก่กรรม
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">อาชีพ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Occupation
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Occupation
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">ลักษณะงาน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.NatureOfWork
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.NatureOfWork
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">ตำแหน่ง/ยศ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Position
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Position
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">รายได้ต่อเดือน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.MonthlyIncome
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.MonthlyIncome
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">สถานที่ทำงาน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Workplace
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Workplace
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">จังหวัด:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Province
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Province
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-2">
                      <span class="pl-2">โทรศัพท์:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Phone
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Phone
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-2">
                      <span class="pl-2">โทรศัพท์มือถือ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Mobile
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Mobile
                        }}
                      </p>
                    </div>
                    <!-- ****************** ข้อมูลบิดา **************** -->
                    <div class="col-12 col-sm-12">
                      <hr />
                    </div>
                    <!-- ****************** ข้อมูลมารดา **************** -->
                    <div class="col-6 col-sm-6 col-md-4">
                      <span class="pl-2">ชื่อมารดา:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Name
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Name
                        }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4">
                      <span class="pl-2">อายุ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Age
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Age
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 mt-3 pl-3">
                      <input
                        v-if="!previewMode"
                        class="form-check-input"
                        type="radio"
                        name="MotherAlive"
                        :value="1"
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Alive
                        "
                      />
                      <label
                        class="form-check-label pl-1"
                        for="inlineRadio1"
                        v-if="!previewMode"
                      >
                        ยังมีชีวิตอยู่
                      </label>
                      <p
                        class="mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Alive == 1
                            ? ''
                            : 'd-none'
                        "
                      >
                        สถานะภาพ: <br />
                        <span> ยังมีชีวิตอยู่ </span>
                      </p>
                      <br />
                      <input
                        v-if="!previewMode"
                        class="form-check-input"
                        type="radio"
                        name="MotherAlive"
                        :value="0"
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Alive
                        "
                      />
                      <label
                        class="form-check-label pl-1"
                        for="inlineRadio2"
                        v-if="!previewMode"
                      >
                        ถึงแก่กรรม
                      </label>
                      <p
                        class="mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Father.Alive == 0
                            ? ''
                            : 'd-none'
                        "
                      >
                        สถานะภาพ: <br />
                        <span> ถึงแก่กรรม </span>
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">อาชีพ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Occupation
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Occupation
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">ลักษณะงาน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.NatureOfWork
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.NatureOfWork
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">ตำแหน่ง/ยศ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Position
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Position
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">รายได้ต่อเดือน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.MonthlyIncome
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.MonthlyIncome
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">สถานที่ทำงาน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Workplace
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.previewMode
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-2">จังหวัด:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Province
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Province
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-2">
                      <span class="pl-2">โทรศัพท์:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Phone
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Phone
                        }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-2">
                      <span class="pl-2">โทรศัพท์มือถือ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Mobile
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <p v-if="previewMode" class="pl-2">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Mother.Mobile
                        }}
                      </p>
                    </div>
                    <!-- ****************** ข้อมูลมารดา **************** -->
                    <div class="col-12 col-sm-12">
                      <hr />
                    </div>
                    <!-- ****************** ข้อมูลที่อยู่อาศัย **************** -->
                    <div class="col-12 col-sm-12">
                      <p class="mb-1">สถานะที่อยู่อาศัย</p>
                      <ul style="list-style-type: none" class="pl-1">
                        <li>
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusResidence"
                            :value="0"
                            v-model="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .Rentinghouse.Status
                            "
                          />
                          <span class="pl-1" v-if="!previewMode">
                            บิดา/มารดาของผู้ขอทุนมีที่อยู่อาศัยเป็นของตนเอง
                          </span>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .Rentinghouse.Status == 0
                                ? ''
                                : 'd-none'
                            "
                          >
                            บิดา/มารดาของผู้ขอทุนมีที่อยู่อาศัยเป็นของตนเอง
                          </span>
                        </li>
                        <li>
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusResidence"
                            :value="1"
                            v-model="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .Rentinghouse.Status
                            "
                          />
                          <span class="pl-1" v-if="!previewMode"
                            >อาศัยอยู่กับผู้อื่น</span
                          >
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .Rentinghouse.Status == 1
                                ? ''
                                : 'd-none'
                            "
                          >
                            อาศัยอยู่กับผู้อื่น
                          </span>
                        </li>
                        <li>
                          <div class="row">
                            <div class="col-6">
                              <input
                                v-if="!previewMode"
                                class="form-check-input"
                                type="radio"
                                name="statusResidence"
                                :value="2"
                                v-model="
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .Status
                                "
                              />
                              <span class="pl-1" v-if="!previewMode">เช่าบ้านอยู่</span>
                              <span
                                class="pl-2"
                                v-if="previewMode"
                                :class="
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .Status == 2
                                    ? ''
                                    : 'd-none'
                                "
                              >
                                เช่าบ้านอยู่
                              </span>
                            </div>
                            <div
                              class="col-6"
                              :class="
                                ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                  .Rentinghouse.Status == 2
                                  ? ''
                                  : 'd-none'
                              "
                            >
                              <span class="pl-1">ค่าเช่าเดือนละ(บาท)</span>
                              <input
                                v-if="!previewMode"
                                type="text"
                                class="ml-3 w-50 mb-3"
                                required
                                placeholder="---"
                                style="
                                  padding: 1px;
                                  padding-left: 10px;
                                  margin-bottom: 0px !important;
                                "
                                v-model="
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .MonthlyRent
                                "
                                :disabled="
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .Status == 2
                                    ? false
                                    : true
                                "
                              />
                              <span class="pl-2" v-if="previewMode">
                                {{
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .MonthlyRent
                                }}
                                บาท
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="row">
                            <div class="col-6">
                              <input
                                v-if="!previewMode"
                                class="form-check-input"
                                type="radio"
                                name="statusResidence"
                                :value="3"
                                v-model="
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .Status
                                "
                              />
                              <span class="pl-1" v-if="!previewMode">เช่าที่ดิน</span>
                              <span
                                class="pl-2"
                                v-if="previewMode"
                                :class="
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .Status == 3
                                    ? ''
                                    : 'd-none'
                                "
                              >
                                เช่าที่ดิน
                              </span>
                            </div>
                            <div
                              class="col-6"
                              :class="
                                ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                  .Rentinghouse.Status == 3
                                  ? ''
                                  : 'd-none'
                              "
                            >
                              <span class="pl-1">ค่าเช่าเดือนละ(บาท)</span>
                              <input
                                v-if="!previewMode"
                                v-model="
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .MonthlyRent
                                "
                                :disabled="
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .Status == 3
                                    ? false
                                    : true
                                "
                                type="text"
                                class="ml-3 w-50 mb-3"
                                required
                                placeholder="---"
                                style="
                                  padding: 1px;
                                  padding-left: 10px;
                                  margin-bottom: 0px !important;
                                "
                              />
                              <span class="pl-2" v-if="previewMode">
                                {{
                                  ScholarshipApplicant
                                    .FamilyStatusOfTheScholarshipApplicant.Rentinghouse
                                    .MonthlyRent
                                }}
                                บาท
                              </span>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <p class="mb-1">สถานภาพ</p>
                      <ul style="list-style-type: none" class="pl-1">
                        <li>
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFamily"
                            :value="0"
                            v-model="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .RelationshipStatus
                            "
                          />
                          <span class="pl-1" v-if="!previewMode"
                            >บิดามารดาอยู่ด้วยกัน</span
                          >
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .RelationshipStatus == 0
                                ? ''
                                : 'd-none'
                            "
                          >
                            บิดามารดาอยู่ด้วยกัน
                          </span>
                        </li>
                        <li>
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFamily"
                            :value="1"
                            v-model="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .RelationshipStatus
                            "
                          />
                          <span class="pl-1" v-if="!previewMode">แยกกันอยู่</span>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .RelationshipStatus == 1
                                ? ''
                                : 'd-none'
                            "
                          >
                            แยกกันอยู่
                          </span>
                        </li>
                        <li>
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFamily"
                            :value="2"
                            v-model="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .RelationshipStatus
                            "
                          />
                          <span class="pl-1" v-if="!previewMode">หย่า</span>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                                .RelationshipStatus == 2
                                ? ''
                                : 'd-none'
                            "
                          >
                            หย่า
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 col-sm-6">
                      <span class="mb-1 pl-3"> ผู้ขอทุนมีพี่น้อง(รวมตนเอง): </span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-70 mt-2"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Siblings.Number
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Siblings.Number
                        }}
                      </span>
                      คน
                    </div>
                    <div class="col-12 col-sm-6">
                      <span class="mb-1"> ผู้ขอทุนเป็นบุตรคนที่: </span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-70 mt-2"
                        required
                        v-model="
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Siblings.ChildCurrent
                        "
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{
                          ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant
                            .Siblings.ChildCurrent
                        }}
                      </span>
                      คน
                    </div>
                    <!-- ****************** ข้อมูลที่อยู่อาศัย **************** -->
                  </div>
                </div>
                <!-- ******************สถานภาพครอบครัวของผู้ขอทุน**************** -->
                <!-- ******************การศึกษา และอาชีพของพี่น้อง**************** -->
                <div class="col-12 col-sm-12 mt-5">
                  <h5 class="text-dark text-underline">
                    การศึกษา อาชีพ ของพี่น้องและตนเอง
                  </h5>
                </div>
                <div class="col-12 col-sm-12 mt-4">
                  <div class="d-none d-sm-block">
                    <div class="row text-center">
                      <div class="col-sm-2">เพศ</div>
                      <div class="col-sm-4">สถานที่ทำงาน/สถานศึกษา</div>
                      <div class="col-sm-3">ระดับการศึกษา</div>
                      <div class="col-sm-3">รายได้เฉลี่ยต่อเดือน</div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-for="(item, key) in ScholarshipApplicant.SiblingEducationAndCareer"
                    :key="key"
                  >
                    <div class="col-1 col-sm-1 col-sm-1 p-1 pt-1 d-none">
                      <input type="text" class="d-none" required v-model="item.No" />
                    </div>
                    <div class="col-4 col-sm-2 col-sm-1 p-1">
                      <span class="d-block d-sm-none">เพศ: </span>

                      <select
                        v-if="!previewMode"
                        style="padding: 4px; padding-left: 10px"
                        class="w-100 ml-1"
                        required
                        v-model="item.Gender"
                      >
                        <option selected disabled :value="null">---</option>
                        <option value="ช">ชาย</option>
                        <option value="ญ">หญิง</option>
                      </select>
                      <span class="pl-2" v-if="previewMode">
                        {{ item.Gender }}
                      </span>
                    </div>
                    <div class="col-8 col-sm-4 col-sm-4 p-1">
                      <span class="d-block d-sm-none"> สถานที่ทำงาน/สถานศึกษา: </span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="item.Workplace"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ item.Workplace }}
                      </span>
                    </div>
                    <div class="col-6 col-sm-3 col-sm-3 p-1">
                      <span class="d-block d-sm-none">ระดับการศึกษา: </span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="item.Education"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ item.Education }}
                      </span>
                    </div>
                    <div class="col-6 col-sm-3 col-sm-3 p-1">
                      <span class="d-block d-sm-none">รายได้เฉลี่ยต่อเดือน: </span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="item.AverageMonthlyIncome"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ item.AverageMonthlyIncome }}
                      </span>
                    </div>
                    <div class="col-12 p-1 d-block d-sm-none">
                      <hr />
                    </div>
                  </div>
                  <div class="text-center" v-if="!previewMode">
                    <span class="btn btn-app mt-4 align-center mr-1" @click="addFamily">
                      เพิ่ม
                    </span>
                    <span
                      class="btn btn-app mt-4 align-center ml-1"
                      @click="removeFamily()"
                      :class="
                        ScholarshipApplicant.SiblingEducationAndCareer.length <= 1
                          ? 'd-none'
                          : ''
                      "
                    >
                      ลบ
                    </span>
                  </div>
                </div>
                <!-- ******************การศึกษา และอาชีพของพี่น้อง**************** -->
                <!-- **********************ผู้อุปการะ********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <h5 class="text-dark text-underline">ผู้อุปการะ</h5>
                </div>
                <div class="col-12 col-sm-12 mt-1">
                  <div class="row">
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-1">ผู้ขอทุนได้รับการอุปการะเลี้ยงดูจาก(ชื่อ):</p>
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Name }}
                      </p>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Name"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-1">เกี่ยวข้องเป็น:</p>
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Relations }}
                      </p>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Relations"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                    </div>
                    <div class="col-12 col-md-12 mt-4 mb-2">
                      <span class="pl-3 text-dark">ที่อยู่ของผู้อุปการะ</span>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">บ้านเลขที่:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Number"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Number }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">หมู่ที่:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Moo"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Moo }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">ถนน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Road"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Road }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">ตำบล:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Tambon"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Tambon }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">อำเภอ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.District"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.District }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">จังหวัด:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Province"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Province }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">รหัสไปรษณีย์:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Postcode"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Postcode }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">อาชีพของผู้อุปการะ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Occupation"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Occupation }}
                      </p>
                    </div>
                    <div class="col-12 col-md-4 mt-1">
                      <span class="pl-1">ตำแหน่ง/ลักษณะงาน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Position"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Position }}
                      </p>
                    </div>
                    <div class="col-12 col-md-4 mt-1">
                      <span class="pl-1">สถานที่ทำงาน:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Workplace"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Workplace }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">โทรศัพท์:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Phone"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2 mb-0" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Phone }}
                      </p>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 mt-1">
                      <span class="pl-1">โทรศัพท์มือถือ:</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="ScholarshipApplicant.Patron.Mobile"
                        placeholder="---"
                        style="padding: 2.5px"
                      />
                      <p class="pl-2 mb-0" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Mobile }}
                      </p>
                    </div>
                    <div class="col-12 col-md-6 mt-1">
                      <span class="pl-1">ผู้อุปการะมีภาระเลี้ยงดูผู้อื่น </span>
                      <p class="pl-2 mb-0" v-if="previewMode">
                        จำนวน: {{ ScholarshipApplicant.Patron.SponsorCount }} คน
                      </p>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-65"
                        required
                        v-model="ScholarshipApplicant.Patron.SponsorCount"
                        placeholder="---"
                        style="padding: 2.5px"
                      />

                      <span class="pl-1" v-if="!previewMode">คน</span>
                    </div>
                    <div class="col-12 col-md-6 mt-3">
                      <span class="pl-1">ในจำนวนนี้เป็นบุตร:</span>
                      <p class="pl-2 mb-0" v-if="previewMode">
                        {{ ScholarshipApplicant.Patron.Sibling }} คน
                      </p>
                      <span class="pl-1"> &emsp;&emsp;&ensp;&ensp;</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-65"
                        required
                        v-model="ScholarshipApplicant.Patron.Sibling"
                        placeholder="---"
                        style="padding: 2.5px"
                      />

                      <span class="pl-1" v-if="!previewMode">คน</span>
                    </div>
                  </div>
                </div>
                <!-- **********************ผู้อุปการะ********************* -->
                <div class="col-12 col-sm-12 mt-1">
                  <div class="row"></div>
                </div>
                <!-- **********************สภาพการอยู่อาศัยของผู้ขอทุน********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <h5 class="text-dark text-underline">สภาพการอยู่อาศัยของผู้ขอทุน</h5>
                </div>
                <div class="col-12 col-sm-12 mt-0">
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12">
                      <ul style="list-style-type: none" class="row">
                        <li class="col-12 col-sm-6 col-md-6 mt-1">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFam"
                            :value="0"
                            v-model="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status
                            "
                            required
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            อยู่กับบิดา / มารดา
                          </label>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 0
                                ? ''
                                : 'd-none'
                            "
                          >
                            <h6 class="text-dark">อยู่กับบิดา / มารดา</h6>
                          </span>
                        </li>
                        <li class="col-12 col-sm-6 col-md-6 mt-1">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFam"
                            :value="1"
                            v-model="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            อยู่กับบิดา
                          </label>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 1
                                ? ''
                                : 'd-none'
                            "
                          >
                            <h6 class="text-dark">อยู่กับบิดา</h6>
                          </span>
                        </li>
                        <li class="col-12 col-sm-6 col-md-6 mt-1">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFam"
                            :value="2"
                            v-model="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            อยู่กับมารดา
                          </label>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 2
                                ? ''
                                : 'd-none'
                            "
                          >
                            <h6 class="text-dark">อยู่กับมารดา</h6>
                          </span>
                        </li>
                        <li class="col-12 col-sm-6 col-md-6 mt-1">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFam"
                            :value="3"
                            v-model="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            อยู่กับผู้อุปการะ
                          </label>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 3
                                ? ''
                                : 'd-none'
                            "
                          >
                            <h6 class="text-dark">อยู่กับผู้อุปการะ</h6>
                          </span>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12 mt-1">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFam"
                            :value="4"
                            v-model="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            อยู่หอพัก
                          </label>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 4
                                ? ''
                                : 'd-none'
                            "
                          >
                            <h6 class="text-dark">อยู่หอพัก</h6>
                          </span>
                        </li>
                        <li
                          class="col-12 col-sm-12 col-md-12 mt-1"
                          :class="
                            ScholarshipApplicant.ApplicantDetail.Dormitory.status == 4
                              ? ''
                              : 'd-none'
                          "
                        >
                          <div class="row pl-3">
                            <div class="col-12 col-sm-6 col-md-6">
                              <span> ชื่อ: </span>
                              <input
                                v-if="!previewMode"
                                type="text"
                                class="ml-1 w-100 pl-1"
                                required
                                placeholder="---"
                                style="padding: 2.5px"
                                v-model="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .name
                                "
                                :disabled="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.status ==
                                  4
                                    ? false
                                    : true
                                "
                              />
                              <p class="pl-2 mb-2" v-if="previewMode">
                                {{
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .name
                                }}
                              </p>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6">
                              <span> สถานที่ติดต่อ: </span>
                              <input
                                v-if="!previewMode"
                                type="text"
                                class="ml-1 w-100 pl-1"
                                required
                                placeholder="---"
                                style="padding: 2.5px"
                                v-model="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .locations
                                "
                                :disabled="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.status ==
                                  4
                                    ? false
                                    : true
                                "
                              />
                              <p class="pl-2 mb-2" v-if="previewMode">
                                {{
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .locations
                                }}
                              </p>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6">
                              <span> ห้อง: </span>
                              <input
                                v-if="!previewMode"
                                type="text"
                                class="ml-1 w-100 pl-1"
                                required
                                placeholder="---"
                                style="padding: 2.5px"
                                v-model="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .room
                                "
                                :disabled="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.status ==
                                  4
                                    ? false
                                    : true
                                "
                              />
                              <p class="pl-2 mb-2" v-if="previewMode">
                                {{
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .room
                                }}
                              </p>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6">
                              <span> หมายเลขโทรศัพท์: </span>
                              <input
                                v-if="!previewMode"
                                type="text"
                                class="ml-1 w-100 pl-1"
                                required
                                placeholder="---"
                                style="padding: 2.5px"
                                v-model="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .mobile
                                "
                                :disabled="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.status ==
                                  4
                                    ? false
                                    : true
                                "
                              />
                              <p class="pl-2 mb-2" v-if="previewMode">
                                {{
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .mobile
                                }}
                              </p>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6">
                              <span> ค่าเช่า/เดือน: </span>
                              <input
                                v-if="!previewMode"
                                type="text"
                                class="ml-1 w-100 pl-1"
                                required
                                placeholder="---"
                                style="padding: 2.5px"
                                v-model="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .price
                                "
                                :disabled="
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.status ==
                                  4
                                    ? false
                                    : true
                                "
                              />
                              <p class="pl-2 mb-0" v-if="previewMode">
                                {{
                                  ScholarshipApplicant.ApplicantDetail.Dormitory.Detail
                                    .price
                                }}
                              </p>
                            </div>
                          </div>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12 mt-1">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFam"
                            :value="5"
                            v-model="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            อาศัยอยู่กับเพื่อน/ผู้อื่น
                          </label>
                          <span
                            class="pl-2"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 5
                                ? ''
                                : 'd-none'
                            "
                          >
                            อาศัยอยู่กับเพื่อน/ผู้อื่น
                          </span>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12 mt-1">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="statusFam"
                            :value="6"
                            v-model="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            อื่น ๆ
                          </label>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-3 w-90 pl-1"
                            required
                            placeholder="---"
                            style="padding: 2.5px"
                            :disabled="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 6
                                ? false
                                : true
                            "
                            :class="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 6
                                ? ''
                                : 'd-none'
                            "
                            v-model="ScholarshipApplicant.ApplicantDetail.Dormitory.Other"
                          />
                          <span
                            class="pl-4"
                            v-if="previewMode"
                            :class="
                              ScholarshipApplicant.ApplicantDetail.Dormitory.status == 6
                                ? ''
                                : 'd-none'
                            "
                          >
                            {{ ScholarshipApplicant.ApplicantDetail.Dormitory.Other }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- **********************สภาพการอยู่อาศัยของผู้ขอทุน********************* -->
                <div class="col-12 col-sm-12 mt-1">
                  <div class="row"></div>
                </div>
                <!-- **********************รายได้ / รายจ่ายของผู้ขอทุน********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <h5 class="text-dark text-underline">รายได้ / รายจ่ายของผู้ขอทุน</h5>
                </div>
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 text-underline">
                      ได้รับเงินมาใช้จ่าย
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-1">
                      <span
                        class="pl-2 mb-1"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.DailyIncome.IncomeType ==
                          0
                            ? ''
                            : 'd-none'
                        "
                      >
                        รายวัน
                      </span>
                      <span
                        class="pl-2 mb-1"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.DailyIncome.IncomeType ==
                          1
                            ? ''
                            : 'd-none'
                        "
                      >
                        รายสัปดาห์
                      </span>
                      <span
                        class="pl-2 mb-1"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.DailyIncome.IncomeType ==
                          2
                            ? ''
                            : 'd-none'
                        "
                      >
                        รายเดือน
                      </span>
                      <span v-if="previewMode">คิดเป็นวันละ</span>
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.IncomeAndExpenses.DailyIncome.PerDay }}
                      </span>
                      <span v-if="previewMode" class="pl-2">บาท</span>
                      <ul style="list-style-type: none" class="row pl-2">
                        <li class="col-12 col-sm-6 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="DailyIncome"
                            :value="0"
                            required
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.DailyIncome
                                .IncomeType
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            รายวัน
                          </label>
                        </li>
                        <li class="col-12 col-sm-6 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="DailyIncome"
                            :value="1"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.DailyIncome
                                .IncomeType
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            รายสัปดาห์
                          </label>
                        </li>
                        <li class="col-12 col-sm-6 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="DailyIncome"
                            :value="2"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.DailyIncome
                                .IncomeType
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            รายเดือน
                          </label>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12 mt-2" v-if="!previewMode">
                          <span>คิดเป็นวันละ</span>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12 mt-2" v-if="!previewMode">
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-50 pl-1"
                            required
                            placeholder="---"
                            style="padding: 2.5px"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.DailyIncome.PerDay
                            "
                          />
                          <span class="pl-2" v-if="previewMode">
                            {{
                              ScholarshipApplicant.IncomeAndExpenses.DailyIncome.PerDay
                            }}
                          </span>
                          <span class="pl-2">บาท</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 text-underline">
                      รับประทานอาหารเช้า
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-1">
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.BreakFast.Location == 0
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่บ้าน
                      </span>
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.BreakFast.Location == 1
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่มหาวิทยาลัย <span>มื้อละ</span>
                      </span>
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.BreakFast.Location == 2
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่อื่น <span>มื้อละ</span>
                      </span>
                      <span v-if="previewMode">มื้อละ</span>
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.IncomeAndExpenses.BreakFast.Price }}
                      </span>
                      <span class="pl-2" v-if="previewMode">บาท</span>
                      <ul style="list-style-type: none" class="row pl-2">
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            required
                            name="BreakFast"
                            :value="0"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.BreakFast.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่บ้าน
                          </label>
                        </li>
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="BreakFast"
                            :value="1"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.BreakFast.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่มหาวิทยาลัย
                          </label>
                        </li>
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="BreakFast"
                            :value="2"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.BreakFast.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่อื่น
                          </label>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12" v-if="!previewMode">
                          <span>มื้อละ</span>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12" v-if="!previewMode">
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-50 pl-1"
                            required
                            placeholder="---"
                            style="padding: 2.5px"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.BreakFast.Price
                            "
                          />
                          <span class="pl-2" v-if="previewMode">
                            {{ ScholarshipApplicant.IncomeAndExpenses.BreakFast.Price }}
                          </span>
                          <span class="pl-2">บาท</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 text-underline">
                      รับประทานอาหารกลางวัน
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-1">
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.lunch.Location == 0
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่บ้าน
                      </span>
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.lunch.Location == 1
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่มหาวิทยาลัย <span>มื้อละ</span>
                      </span>
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.lunch.Location == 2
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่อื่น <span>มื้อละ</span>
                      </span>
                      <span v-if="previewMode">มื้อละ</span>
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.IncomeAndExpenses.lunch.Price }}
                      </span>
                      <span class="pl-2" v-if="previewMode">บาท</span>
                      <ul style="list-style-type: none" class="row pl-2">
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            required
                            name="lunch"
                            :value="0"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.lunch.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่บ้าน
                          </label>
                        </li>
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="lunch"
                            :value="1"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.lunch.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่มหาวิทยาลัย
                          </label>
                        </li>
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="lunch"
                            :value="2"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.lunch.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่อื่น
                          </label>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12" v-if="!previewMode">
                          <span>มื้อละ</span>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12" v-if="!previewMode">
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-50 pl-1"
                            required
                            placeholder="---"
                            style="padding: 2.5px"
                            v-model="ScholarshipApplicant.IncomeAndExpenses.lunch.Price"
                          />
                          <span class="pl-2" v-if="previewMode">
                            {{ ScholarshipApplicant.IncomeAndExpenses.lunch.Price }}
                          </span>
                          <span class="pl-2">บาท</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 text-underline">
                      รับประทานอาหารเย็น
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-1">
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.dinner.Location == 0
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่บ้าน
                      </span>
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.dinner.Location == 1
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่มหาวิทยาลัย <span>มื้อละ</span>
                      </span>
                      <span
                        class="pl-2 mb-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.IncomeAndExpenses.dinner.Location == 2
                            ? ''
                            : 'd-none'
                        "
                      >
                        ที่อื่น <span>มื้อละ</span>
                      </span>
                      <span v-if="previewMode">มื้อละ</span>
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.IncomeAndExpenses.dinner.Price }}
                      </span>
                      <span class="pl-2" v-if="previewMode">บาท</span>
                      <ul style="list-style-type: none" class="row pl-2">
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            required
                            name="dinner"
                            :value="0"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.dinner.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่บ้าน
                          </label>
                        </li>
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="dinner"
                            :value="1"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.dinner.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่มหาวิทยาลัย
                          </label>
                        </li>
                        <li class="col-12 col-sm-4 col-md-4">
                          <input
                            v-if="!previewMode"
                            class="form-check-input"
                            type="radio"
                            name="dinner"
                            :value="2"
                            v-model="
                              ScholarshipApplicant.IncomeAndExpenses.dinner.Location
                            "
                          />
                          <label
                            class="form-check-label pl-1"
                            for="inlineRadio1"
                            v-if="!previewMode"
                          >
                            ที่อื่น
                          </label>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12" v-if="!previewMode">
                          <span>มื้อละ</span>
                        </li>
                        <li class="col-12 col-sm-12 col-md-12" v-if="!previewMode">
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-50 pl-1"
                            required
                            placeholder="---"
                            style="padding: 2.5px"
                            v-model="ScholarshipApplicant.IncomeAndExpenses.dinner.Price"
                          />
                          <span class="pl-2" v-if="previewMode">
                            {{ ScholarshipApplicant.IncomeAndExpenses.dinner.Price }}
                          </span>
                          <span class="pl-2">บาท</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 text-underline mt-2">
                      ค่าใช้จ่ายในการเดินทาง
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-1 pl-3">
                      <span>ประมาณ</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-50 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.IncomeAndExpenses.ApproximateTravelExpenses
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{
                          ScholarshipApplicant.IncomeAndExpenses.ApproximateTravelExpenses
                        }}
                      </span>
                      <span class="pl-2">บาท/วัน</span>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 text-underline mt-4">
                      ค่าใช้จ่ายเพื่อการศึกษา
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-1 pl-3">
                      <span>ประมาณ</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-50 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="ScholarshipApplicant.IncomeAndExpenses.EducationExpenses"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.IncomeAndExpenses.EducationExpenses }}
                      </span>
                      <span class="pl-2">บาท/เดือน</span>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 text-underline mt-4">
                      ค่าใช้จ่ายอื่น ๆ
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-1 pl-3">
                      <span>ประมาณ</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-50 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="ScholarshipApplicant.IncomeAndExpenses.OtherExpenses"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.IncomeAndExpenses.OtherExpenses }}
                      </span>
                      <span class="pl-2">บาท/เดือน</span>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 text-underline mt-4">
                      หารายได้พิเศษโดย
                    </div>
                    <div class="col-12 col-sm-4 col-md-3 mt-1 pl-3">
                      <span>ลักษณะงาน</span>
                    </div>
                    <div class="col-12 col-sm-8 col-md-8 mt-1 pl-3">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-80 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.IncomeAndExpenses.EarnExtraMoney.Detail
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.IncomeAndExpenses.EarnExtraMoney.Detail }}
                      </span>
                    </div>
                    <div class="col-12 col-sm-4 col-md-3 mt-2 pl-3">
                      <span>มีรายได้ ประมาณ</span>
                    </div>
                    <div class="col-12 col-sm-8 col-md-8 mt-1 pl-3">
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-50 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.IncomeAndExpenses.EarnExtraMoney.price
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.IncomeAndExpenses.EarnExtraMoney.price }}
                      </span>
                      <span class="pl-2">บาท/วัน</span>
                    </div>
                  </div>
                </div>
                <!-- **********************รายได้ / รายจ่ายของผู้ขอทุน********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row"></div>
                </div>
                <!-- **********************ทุนการศึกษาอื่นที่เคยได้รับ********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <h5 class="text-dark text-underline mb-0">
                    ทุนการศึกษาอื่นที่เคยได้รับ
                  </h5>
                </div>
                <div class="col-12 col-sm-12 mt-1">
                  <ul style="list-style-type: none" class="pl-3 row">
                    <li class="col-12 col-sm-12 col-md-12 mt-1">
                      <input
                        v-if="!previewMode"
                        class="form-check-input"
                        type="radio"
                        required
                        name="ScholarshipsHistoty"
                        :value="0"
                        v-model="
                          ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                            .ScholarshipsHistoty
                        "
                      />
                      <label
                        class="form-check-label pl-1"
                        for="inlineRadio1"
                        v-if="!previewMode"
                      >
                        ไม่เคยได้รับมาก่อน
                      </label>
                      <span
                        class="pl-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                            .ScholarshipsHistoty == 0
                            ? ''
                            : 'd-none'
                        "
                      >
                        <h6 class="text-dark">ไม่เคยได้รับมาก่อน</h6>
                      </span>
                    </li>
                    <li class="col-12 col-sm-12 col-md-12 mt-1">
                      <input
                        v-if="!previewMode"
                        class="form-check-input"
                        type="radio"
                        name="ScholarshipsHistoty"
                        :value="1"
                        v-model="
                          ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                            .ScholarshipsHistoty
                        "
                      />
                      <label
                        class="form-check-label pl-1"
                        for="inlineRadio1"
                        v-if="!previewMode"
                      >
                        เคยได้รับทุน
                      </label>
                      <span
                        class="pl-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                            .ScholarshipsHistoty == 1
                            ? ''
                            : 'd-none'
                        "
                      >
                        <h5 class="text-dark">เคยได้รับทุน</h5>
                      </span>
                    </li>
                    <li
                      class="col-12 col-sm-12 col-md-12 mt-1"
                      :class="
                        ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                          .ScholarshipsHistoty == 1
                          ? ''
                          : 'd-none'
                      "
                    >
                      <div class="row pl-3">
                        <div class="col-12 col-sm-6 col-md-6">
                          <span> ชื่อทุนที่ได้รับ: </span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100 pl-1"
                            required
                            placeholder="---"
                            style="padding: 2.5px"
                            v-model="
                              ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                .detail.Name
                            "
                            :disabled="
                              ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                .ScholarshipsHistoty == 1
                                ? false
                                : true
                            "
                          />
                          <span class="pl-2" v-if="previewMode">
                            {{
                              ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                .detail.Name
                            }}
                          </span>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <span> เมื่อปี พ.ศ. </span>
                          <input
                            v-if="!previewMode"
                            type="text"
                            class="ml-1 w-100 pl-1"
                            required
                            placeholder="---"
                            style="padding: 2.5px"
                            v-model="
                              ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                .detail.Year
                            "
                            :disabled="
                              ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                .ScholarshipsHistoty == 1
                                ? false
                                : true
                            "
                          />
                          <span class="pl-2" v-if="previewMode">
                            {{
                              ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                .detail.Year
                            }}
                          </span>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 mt-2">
                          <span> เป็นทุนประเภท </span>
                          <ul style="list-style-type: none" class="row">
                            <li class="col-12 mt-2">
                              <input
                                v-if="!previewMode"
                                class="form-check-input"
                                type="radio"
                                :disabled="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .ScholarshipsHistoty == 1
                                    ? false
                                    : true
                                "
                                required
                                name="ScholarshipsHistotyType"
                                :value="0"
                                v-model="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Name
                                "
                              />
                              <label
                                class="form-check-label pl-1"
                                for="inlineRadio1"
                                v-if="!previewMode"
                              >
                                เฉพาะปี
                              </label>
                              <span
                                class="pl-2"
                                v-if="previewMode"
                                :class="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Name == 0
                                    ? ''
                                    : 'd-none'
                                "
                              >
                                เฉพาะปี
                              </span>
                            </li>
                            <li
                              class="col-12 mt-2"
                              :class="
                                ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                  .detail.Type.Name == 0
                                  ? ''
                                  : 'd-none'
                              "
                            >
                              <span class="pl-2">มูลค่าทุน:</span>
                              <input
                                v-if="!previewMode"
                                type="text"
                                class="ml-1 w-40 pl-1"
                                required
                                placeholder="---"
                                style="padding: 2.5px"
                                v-model="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Price
                                "
                                :disabled="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Name == 0
                                    ? false
                                    : true
                                "
                              />
                              <span class="pl-2" v-if="previewMode">
                                {{
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Price
                                }}
                              </span>
                              <span class="pl-2">บาท</span>
                            </li>
                            <li class="col-12 mt-2">
                              <input
                                v-if="!previewMode"
                                class="form-check-input"
                                type="radio"
                                :disabled="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .ScholarshipsHistoty == 1
                                    ? false
                                    : true
                                "
                                name="ScholarshipsHistotyType"
                                :value="1"
                                v-model="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Name
                                "
                              />
                              <label
                                class="form-check-label pl-1"
                                for="inlineRadio1"
                                v-if="!previewMode"
                              >
                                ต่อเนื่องจนจบการศึกษา
                              </label>
                              <span
                                class="pl-2"
                                v-if="previewMode"
                                :class="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Name == 1
                                    ? ''
                                    : 'd-none'
                                "
                              >
                                ต่อเนื่องจนจบการศึกษา
                              </span>
                            </li>
                            <li
                              class="col-12 mt-2"
                              :class="
                                ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                  .detail.Type.Name == 1
                                  ? ''
                                  : 'd-none'
                              "
                            >
                              <span class="pl-2">มูลค่าทุน:</span>
                              <input
                                v-if="!previewMode"
                                type="text"
                                class="ml-1 w-40 pl-1"
                                required
                                placeholder="---"
                                style="padding: 2.5px"
                                v-model="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Price
                                "
                                :disabled="
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Name == 1
                                    ? false
                                    : true
                                "
                              />
                              <span class="pl-2" v-if="previewMode">
                                {{
                                  ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded
                                    .detail.Type.Price
                                }}
                              </span>
                              <span class="pl-2">บาท</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- **********************ทุนการศึกษาอื่นที่เคยได้รับ********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row"></div>
                </div>
                <!-- **********************ทุนกู้ยืมรัฐบาล (ปีล่าสุด)********************* -->
                <div class="col-12 col-sm-12 mt-2">
                  <h5 class="text-dark text-underline">ทุนกู้ยืมรัฐบาล (ปีล่าสุด)</h5>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-6">
                      <span> ปีการศึกษา: </span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="ScholarshipApplicant.GovernmentScholarships.Year"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.GovernmentScholarships.Year }}
                      </span>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6">
                      <span> จำนวนเงินที่กู้: </span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="ScholarshipApplicant.GovernmentScholarships.Price"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.GovernmentScholarships.Price }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- **********************ทุนกู้ยืมรัฐบาล (ปีล่าสุด)********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row"></div>
                </div>
                <!-- **********************กิจกรรมพิเศษที่เข้าร่วม********************* -->
                <div class="col-12 col-sm-12 mt-2">
                  <h5 class="text-dark text-underline">กิจกรรมพิเศษที่เข้าร่วม</h5>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12">
                      <span> กิจกรรมด้านวิชาการ: </span><br />
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.SpecialEventsAttended.AcademicActivities
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{
                          ScholarshipApplicant.SpecialEventsAttended.AcademicActivities
                        }}
                      </span>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-3">
                      <span> กิจกรรมด้านสาธารณะประโยชน์: </span><br />
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.SpecialEventsAttended
                            .PublicInterestActivities
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{
                          ScholarshipApplicant.SpecialEventsAttended
                            .PublicInterestActivities
                        }}
                      </span>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 mt-3">
                      <span> กิจกรรมด้านกีฬา: </span><br />
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.SpecialEventsAttended.SportsActivities
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.SpecialEventsAttended.SportsActivities }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- **********************กิจกรรมพิเศษที่เข้าร่วม********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row"></div>
                </div>
                <!-- **********************บุคคลที่สามารถให้ข้อมูลเพิ่มเติม (เช่นเพื่อนสนิท / อาจารย์ / ญาติ)********************* -->
                <div class="col-12 col-sm-12 mt-2">
                  <h5 class="text-dark text-underline">
                    บุคคลที่สามารถให้ข้อมูลเพิ่มเติม
                  </h5>
                  <span> (เช่นเพื่อนสนิท / อาจารย์ / ญาติ)</span>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <div class="col-12 col-sm-12 mt-1">
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6">
                        <span class="pl-2"> ชื่อ: </span>
                        <span v-if="previewMode">
                          {{
                            ScholarshipApplicant.ProvideAdditionalInformation.name
                          }} </span
                        ><br v-if="!previewMode" />
                        <input
                          v-if="!previewMode"
                          type="text"
                          class="ml-1 w-100 pl-1"
                          required
                          placeholder="---"
                          style="padding: 2.5px"
                          v-model="ScholarshipApplicant.ProvideAdditionalInformation.name"
                        />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6">
                        <span class="pl-2"> เกี่ยวข้องเป็น: </span>
                        <span v-if="previewMode">
                          {{
                            ScholarshipApplicant.ProvideAdditionalInformation.relations
                          }}
                        </span>
                        <br v-if="!previewMode" />
                        <input
                          v-if="!previewMode"
                          type="text"
                          class="ml-1 w-100 pl-1"
                          required
                          placeholder="---"
                          style="padding: 2.5px"
                          v-model="
                            ScholarshipApplicant.ProvideAdditionalInformation.relations
                          "
                        />
                      </div>
                      <div class="col-12 col-sm-12 mt-4">
                        <span class="pl-3 text-dark"> ที่อยู่ปัจจุบัน </span>
                        <div class="row">
                          <div class="col-12 col-sm-6 col-md-4 mt-1">
                            <span class="pl-2">บ้านเลขที่:</span>
                            <input
                              v-if="!previewMode"
                              type="text"
                              required
                              v-model="
                                ScholarshipApplicant.ProvideAdditionalInformation.Number
                              "
                              placeholder="---"
                              class="ml-1 w-100"
                              style="padding: 2.5px"
                            />
                            <p class="pl-2 mb-0" v-if="previewMode">
                              {{
                                ScholarshipApplicant.ProvideAdditionalInformation.Number
                              }}
                            </p>
                          </div>
                          <div class="col-12 col-sm-6 col-md-4 mt-1">
                            <span class="pl-2">ถนน:</span
                            ><input
                              v-if="!previewMode"
                              type="text"
                              required
                              v-model="
                                ScholarshipApplicant.ProvideAdditionalInformation.Road
                              "
                              placeholder="---"
                              class="ml-1 w-100"
                              style="padding: 2.5px"
                            />
                            <p class="pl-2 mb-0" v-if="previewMode">
                              {{ ScholarshipApplicant.ProvideAdditionalInformation.Road }}
                            </p>
                          </div>
                          <div class="col-12 col-sm-6 col-md-4 mt-1">
                            <span class="pl-2">ตำบล:</span
                            ><input
                              v-if="!previewMode"
                              type="text"
                              required
                              v-model="
                                ScholarshipApplicant.ProvideAdditionalInformation.Tambon
                              "
                              placeholder="---"
                              class="ml-1 w-100"
                              style="padding: 2.5px"
                            />
                            <p class="pl-2 mb-0" v-if="previewMode">
                              {{
                                ScholarshipApplicant.ProvideAdditionalInformation.Tambon
                              }}
                            </p>
                          </div>
                          <div class="col-12 col-sm-6 col-md-4 mt-1">
                            <span class="pl-2">อำเภอ:</span
                            ><input
                              v-if="!previewMode"
                              type="text"
                              required
                              v-model="
                                ScholarshipApplicant.ProvideAdditionalInformation.District
                              "
                              placeholder="---"
                              class="ml-1 w-100"
                              style="padding: 2.5px"
                            />
                            <p class="pl-2 mb-0" v-if="previewMode">
                              {{
                                ScholarshipApplicant.ProvideAdditionalInformation.District
                              }}
                            </p>
                          </div>
                          <div class="col-12 col-sm-6 col-md-4 mt-1">
                            <span class="pl-2">จังหวัด:</span
                            ><input
                              v-if="!previewMode"
                              type="text"
                              required
                              v-model="
                                ScholarshipApplicant.ProvideAdditionalInformation.Province
                              "
                              placeholder="---"
                              class="ml-1 w-100"
                              style="padding: 2.5px"
                            />
                            <p class="pl-2 mb-0" v-if="previewMode">
                              {{
                                ScholarshipApplicant.ProvideAdditionalInformation.Province
                              }}
                            </p>
                          </div>
                          <div class="col-12 col-sm-6 col-md-4 mt-1">
                            <span class="pl-2">โทรศัพท์:</span
                            ><input
                              v-if="!previewMode"
                              type="text"
                              required
                              v-model="
                                ScholarshipApplicant.ProvideAdditionalInformation.Phone
                              "
                              placeholder="---"
                              class="ml-1 w-100"
                              style="padding: 2.5px"
                            />
                            <p class="pl-2 mb-0" v-if="previewMode">
                              {{
                                ScholarshipApplicant.ProvideAdditionalInformation.Phone
                              }}
                            </p>
                          </div>
                          <div class="col-12 col-sm-6 col-md-4 mt-1">
                            <span class="pl-2">โทรศัพท์มือถือ:</span
                            ><input
                              v-if="!previewMode"
                              type="text"
                              required
                              v-model="
                                ScholarshipApplicant.ProvideAdditionalInformation.Mobile
                              "
                              placeholder="---"
                              class="ml-1 w-100"
                              style="padding: 2.5px"
                            />
                            <p class="pl-2 mb-0" v-if="previewMode">
                              {{
                                ScholarshipApplicant.ProvideAdditionalInformation.Mobile
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- **********************บุคคลที่สามารถให้ข้อมูลเพิ่มเติม (เช่นเพื่อนสนิท / อาจารย์ / ญาติ)********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row"></div>
                </div>
                <!-- **********************ความสามารถพิเศษ  ********************* -->
                <div class="col-12 col-sm-12 mt-2">
                  <h5 class="text-dark text-underline">ความสามารถพิเศษ</h5>
                  <span> (เช่น พิมพ์ดีดไทย อังกฤษ ทำบัญชี คอมพิวเตอร์ ฯลฯ) ระบุ</span>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <div class="col-12 col-sm-12 mt-1">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-12">
                        <input
                          v-if="!previewMode"
                          type="text"
                          class="ml-1 w-100 pl-1"
                          required
                          placeholder="---"
                          style="padding: 2.5px"
                          v-model="ScholarshipApplicant.Talent"
                        />
                        <span class="pl-2" v-if="previewMode">
                          {{ ScholarshipApplicant.Talent }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- **********************ความสามารถพิเศษ  ********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row"></div>
                </div>
                <!-- **********************ปัญหาด้านสุขภาพ********************* -->
                <div class="col-12 col-sm-12 mt-2">
                  <h5 class="text-dark text-underline">ปัญหาด้านสุขภาพ</h5>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 mt-1">
                      <span class="pl-2">โรคประจำตัว:</span>
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.HealthProblems.CongenitalDisease.Detail }}
                      </span>
                      <span
                        class="pl-2"
                        v-if="previewMode"
                        :class="
                          ScholarshipApplicant.HealthProblems.CongenitalDisease.Status ===
                          1
                            ? ''
                            : 'd-none'
                        "
                      >
                        ไม่มี
                      </span>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <input
                        v-if="!previewMode"
                        type="radio"
                        name="HealthProblems"
                        class="form-check-input"
                        :value="0"
                        required
                        v-model="
                          ScholarshipApplicant.HealthProblems.CongenitalDisease.Status
                        "
                      />
                      <label
                        for="inlineRadio1"
                        class="form-check-label pl-1"
                        v-if="!previewMode"
                      >
                        มี
                      </label>
                      <div
                        :class="
                          ScholarshipApplicant.HealthProblems.CongenitalDisease.Status ==
                          0
                            ? ''
                            : 'd-none'
                        "
                        v-if="!previewMode"
                      >
                        <span class="ml-3"> ระบุ </span>
                        <input
                          v-if="!previewMode"
                          type="text"
                          class="ml-1 w-50 pl-1"
                          placeholder="---"
                          style="padding: 2.5px"
                          v-model="
                            ScholarshipApplicant.HealthProblems.CongenitalDisease.Detail
                          "
                          :disabled="
                            ScholarshipApplicant.HealthProblems.CongenitalDisease
                              .Status == 0
                              ? false
                              : true
                          "
                        />
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <input
                        v-if="!previewMode"
                        type="radio"
                        name="HealthProblems"
                        class="form-check-input"
                        :value="1"
                        v-model="
                          ScholarshipApplicant.HealthProblems.CongenitalDisease.Status
                        "
                      />
                      <label
                        for="inlineRadio1"
                        class="form-check-label pl-1"
                        v-if="!previewMode"
                      >
                        ไม่มี
                      </label>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 mt-3">
                      <span class="pl-2">ปัญหาด้านอื่น ๆ:</span><br />
                      <span class="pl-2">(ที่เป็นอุปสรรคต่อการเรียน)</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="ScholarshipApplicant.HealthProblems.OtherProblems"
                      />
                      <p class="pl-2 mb-2" v-if="previewMode">
                        {{ ScholarshipApplicant.HealthProblems.OtherProblems }}
                      </p>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 mt-3">
                      <br class="d-none d-sm-block" /><span class="pl-2"
                        >ปัญหาครอบครัว:</span
                      ><br />
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="ScholarshipApplicant.HealthProblems.FamilyProblems"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.HealthProblems.FamilyProblems }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- **********************ปัญหาด้านสุขภาพ********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row"></div>
                </div>
                <!-- **********************อาจารย์ที่ปรึกษา ********************* -->
                <div class="col-12 col-sm-12 mt-2">
                  <h5 class="text-underline text-dark">อาจารย์ที่ปรึกษา</h5>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <span class="pl-2">ชื่อ:</span>
                  <input
                    v-if="!previewMode"
                    type="text"
                    class="ml-1 w-100 pl-1"
                    required
                    placeholder="---"
                    style="padding: 2.5px"
                    v-model="ScholarshipApplicant.Advisor"
                  />
                  <span class="pl-2" v-if="previewMode">
                    {{ ScholarshipApplicant.Advisor }}
                  </span>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <p class="pl-2 text-start">
                    &emsp;ข้าพเจ้าขอรับรองว่าข้อความที่แจ้งไว้ทั้งหมดนี้
                    เป็นความจริงทุกประการ
                  </p>
                </div>
                <!-- **********************อาจารย์ที่ปรึกษา ********************* -->
                <div class="col-12 col-sm-12 mt-4" id="Signature">
                  <div class="row"></div>
                </div>
                <!-- **********************ผู้ขอทุน ********************* -->
                <div class="col-4 col-sm-4 mt-2">
                  <span class="pl-2">ลงชื่อ</span>
                </div>
                <div class="col-8 col-sm-8 mt-2" v-if="!previewMode">
                  <label
                    for="AuthorisedSignatureUpload"
                    class="custom-file-upload btn btn-app ml-2"
                  >
                    ลายเซ็น
                  </label>
                  <input
                    v-if="!previewMode"
                    id="AuthorisedSignatureUpload"
                    type="file"
                    @change="FileSignature"
                    accept="image/*"
                  />
                </div>
                <div class="col-4 col-sm-4 mt-2" v-if="!previewMode"></div>
                <div class="col-7 col-sm-7 text-truncate mt-2 ml-2">
                  {{ FileUploadName }}
                </div>
                <div class="col-4 col-sm-3 mt-2">
                  <span class="pl-2">ชื่อ-สกุล</span>
                </div>
                <div class="col-8 col-sm-9 mt-2">
                  <input
                    v-if="!previewMode"
                    type="text"
                    class="ml-1 w-100 pl-1"
                    required
                    placeholder="---"
                    style="padding: 2.5px"
                    v-model="ScholarshipApplicant.Signature.Name"
                  />
                  <span class="pl-2" v-if="previewMode">
                    {{ ScholarshipApplicant.Signature.Name }}
                  </span>
                </div>
                <div class="col-4 col-sm-3 mt-2">
                  <span class="pl-2">อีเมล</span>
                </div>
                <div class="col-8 col-sm-9 mt-2">
                  <input
                    v-if="!previewMode"
                    type="email"
                    class="ml-1 w-100 pl-1"
                    required
                    placeholder="---"
                    style="padding: 2.5px"
                    v-model="ScholarshipApplicant.Signature.Email"
                  />
                  <span class="pl-2" v-if="previewMode">
                    {{ ScholarshipApplicant.Signature.Email }}
                  </span>
                </div>
                <div class="col-4 col-sm-3 mt-2">
                  <span class="pl-2">วันที่</span>
                </div>
                <div class="col-8 col-sm-9 mt-2">
                  <input
                    v-if="!previewMode"
                    type="date"
                    class="ml-1 w-100 pl-1"
                    required
                    placeholder="---"
                    style="padding: 2.5px"
                    v-model="ScholarshipApplicant.Signature.Date"
                  />
                  <span class="pl-2" v-if="previewMode">
                    {{ ScholarshipApplicant.Signature.Date }}
                  </span>
                </div>
                <div class="col-12 col-sm-12 mt-4">
                  <span class="pl-2 text-underline">หมายเหตุ</span>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <ul class="row" style="list-style-type: none">
                    <li class="col-12 mt-2">
                      1. สถานที่ที่สามารถเรียกตัวได้ทันที ในมหาวิทยาลัย
                    </li>
                    <li class="col-12 col-sm-6 col-md-6 mt-2">
                      <span class="pl-2">ที่ชุมนุม / กลุ่ม</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.Note
                            .PlacesThatCanBeImmediatelySummonedOnCampus.Group
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{
                          ScholarshipApplicant.Note
                            .PlacesThatCanBeImmediatelySummonedOnCampus.Group
                        }}
                      </span>
                    </li>
                    <li class="col-12 col-sm-6 col-md-6 mt-2">
                      <span class="pl-2">ตึก</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.Note
                            .PlacesThatCanBeImmediatelySummonedOnCampus.Nuilding
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{
                          ScholarshipApplicant.Note
                            .PlacesThatCanBeImmediatelySummonedOnCampus.Nuilding
                        }}
                      </span>
                    </li>
                    <li class="col-12 mt-4">2. หมายเลขบัญชีออมทรัพย์</li>
                    <li class="col-12 col-sm-6 col-md-6 mt-2">
                      <span class="pl-2">ชื่อบัญชี</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="ScholarshipApplicant.Note.SavingsAccountNumber.Name"
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Note.SavingsAccountNumber.Name }}
                      </span>
                    </li>
                    <li class="col-12 col-sm-6 col-md-6 mt-2">
                      <span class="pl-2">เลขที่บัญชี</span>
                      <input
                        v-if="!previewMode"
                        type="text"
                        class="ml-1 w-100 pl-1"
                        required
                        placeholder="---"
                        style="padding: 2.5px"
                        v-model="
                          ScholarshipApplicant.Note.SavingsAccountNumber.AccountNumber
                        "
                      />
                      <span class="pl-2" v-if="previewMode">
                        {{ ScholarshipApplicant.Note.SavingsAccountNumber.AccountNumber }}
                      </span>
                    </li>
                  </ul>
                </div>
                <!-- **********************ผู้ขอทุน ********************* -->
                <div class="col-12 col-sm-12 mt-4">
                  <div class="row"></div>
                </div>
                <!-- **********************บรรยายประวัติ สภาพครอบครัว  ********************* -->
                <div class="col-12 mt-2">
                  <h5 class="text-underline text-dark">
                    บรรยายประวัติ สภาพครอบครัว และเหตุผลความจำเป็นในการขอทุน
                  </h5>
                </div>
                <div class="col-12 mt-2 mb-4">
                  <p class="pl-2">เพื่อประโยชน์ในการพิจารณา</p>
                  <textarea
                    v-if="!previewMode"
                    rows="5"
                    class="w-90 pl-2 ml-5"
                    required
                    v-model="ScholarshipApplicant.DescriptionOfFamilyHistory"
                    placeholder="---"
                  ></textarea>
                  <span class="pl-2 ml-5" v-if="previewMode">
                    {{ ScholarshipApplicant.DescriptionOfFamilyHistory }}
                  </span>
                </div>
                <div class="col-12 mt-2" id="HomeMap">
                  <span class="pl-2"> อัปโหลดแผนที่บ้านพอสังเขป </span>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <label
                    for="locationHome"
                    class="custom-file-upload btn btn-app ml-2"
                    v-if="!previewMode"
                  >
                    แผนที่บ้าน
                  </label>
                  <input
                    id="locationHome"
                    type="file"
                    @change="FileMap"
                    accept="image/*"
                  />
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <img :src="FileUploadMapLocationsURL" class="w-100" />
                </div>
                <!-- **********************บรรยายประวัติ สภาพครอบครัว  ********************* -->
              </div>
              <center>
                <button
                  v-if="!previewMode"
                  type="submit"
                  class="btn btn-app mt-4 align-center"
                >
                  <div>ต่อไป</div>
                </button>
                <button
                  type="submit"
                  class="btn btn-app mt-4 align-center mx-1"
                  v-if="previewMode"
                >
                  <div>แก้ไข</div>
                </button>
                <a class="btn btn-app mt-4 align-center mx-1" v-if="previewMode">
                  <div @click="SubmitFormData">ต่อไป</div>
                </a>
              </center>
              <br />
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Body -->

    <!-- Footer -->
    <div class="container p-0">
      <img src="@/assets/img/footer.png" alt="header" width="100%" />
    </div>
    <!-- Footer -->
  </div>
</template>

<script>
// CSS
import "@/assets/bootstrap/bootstrap.min.css";
import "@/assets/bootstrap/animate.css";
import "@/assets/bootstrap/fontface.css";
import "@/assets/css/font.css";
import "@/assets/bootstrap/custom.css";
import "@/assets/css/spacing.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

// Component
import { store } from "@/store";
import axios from "axios";

export default {
  name: "Home",
  store,
  components: {},
  data() {
    return {
      display: false,
      RandomID: null,
      previewMode: false,
      ScholarshipApplicant: {
        Profile: {
          Title: null,
          NameTH: "",
          LastnameTH: "",
          Email: "",
          NameEN: "",
          Image: "",
          StudyingAtTheInstitute: "",
          Faculty: "",
          Major: "",
          StudentCode: "",
          YearClass: "",
          AverageScoreNow: "",
          DateOfBirth: "",
          PlaceOfBirth: "",
          Religion: "",
          Domicile: {
            Number: "",
            Moo: "",
            Road: "",
            Tambon: "",
            District: "",
            Province: "",
            Postcode: "",
            Phone: "",
            Mobile: "",
          },
          CurrentAddress: {
            Number: "",
            Moo: "",
            Road: "",
            Tambon: "",
            District: "",
            Province: "",
            Postcode: "",
            Phone: "",
            Mobile: "",
          },
        },
        BriefEducationalBackground: {
          PrimarySchool: {
            Name: "",
            Province: "",
          },
          JuniorHighSchool: {
            Name: "",
            Province: "",
          },
          HighSchool: {
            Name: "",
            Province: "",
          },
          CumulativeGPA: "",
        },
        FamilyStatusOfTheScholarshipApplicant: {
          Father: {
            Name: "",
            Age: "",
            Alive: "",
            Occupation: "",
            NatureOfWork: "",
            Position: "",
            MonthlyIncome: "",
            Workplace: "",
            Province: "",
            Phone: "",
            Mobile: "",
          },
          Mother: {
            Name: "",
            Age: "",
            Alive: "",
            Occupation: "",
            NatureOfWork: "",
            Position: "",
            MonthlyIncome: "",
            Workplace: "",
            Province: "",
            Phone: "",
            Mobile: "",
          },
          Rentinghouse: {
            Status: null,
            MonthlyRent: "",
          },
          RelationshipStatus: null,
          Siblings: {
            Number: "",
            ChildCurrent: "",
          },
        },
        SiblingEducationAndCareer: [
          {
            No: 0,
            Gender: "",
            Workplace: "",
            Education: "",
            AverageMonthlyIncome: "",
          },
        ],
        Patron: {
          Name: "",
          Relations: "",
          Number: "",
          Moo: "",
          Road: "",
          Tambon: "",
          District: "",
          Province: "",
          Postcode: "",
          Occupation: "",
          Position: "",
          Workplace: "",
          Phone: "",
          Mobile: "",
          SponsorCount: "",
          Sibling: "",
        },
        ApplicantDetail: {
          Dormitory: {
            status: null,
            Detail: {
              name: "",
              locations: "",
              room: "",
              mobile: "",
              price: "",
            },
            Other: "",
          },
        },
        IncomeAndExpenses: {
          DailyIncome: {
            IncomeType: "",
            PerDay: "",
          },
          BreakFast: {
            Location: "",
            Price: "",
          },
          lunch: {
            Location: "",
            Price: "",
          },
          dinner: {
            Location: "",
            Price: "",
          },
          ApproximateTravelExpenses: "",
          EducationExpenses: "",
          OtherExpenses: "",
          EarnExtraMoney: {
            Detail: "",
            price: "",
          },
        },
        OtherScholarshipsPreviouslyAwarded: {
          ScholarshipsHistoty: null,
          detail: {
            Name: "",
            Year: "",
            Type: {
              Name: null,
              Price: "",
            },
          },
        },
        GovernmentScholarships: { Year: "", Price: "" },
        SpecialEventsAttended: {
          AcademicActivities: "",
          PublicInterestActivities: "",
          SportsActivities: "",
        },
        ProvideAdditionalInformation: {
          Number: "",
          Soi: "",
          Moo: "",
          Road: "",
          Tambon: "",
          District: "",
          Province: "",
          Phone: "",
          Mobile: "",
        },
        Talent: "",
        HealthProblems: {
          CongenitalDisease: {
            Status: null,
            Detail: "",
          },
          OtherProblems: "",
          FamilyProblems: "",
        },
        Signature: {
          SignatureImage: null,
          SignatureImageOldName: null,
          Name: "",
          Email: "",
          Day: "",
          Month: "",
          Yaer: "",
        },
        Note: {
          PlacesThatCanBeImmediatelySummonedOnCampus: {
            Group: "",
            Nuilding: "",
          },
          SavingsAccountNumber: {
            Name: "",
            AccountNumber: "",
          },
        },
        DescriptionOfFamilyHistory: "",
        mapLocations: "",
      },
      FileMapLocations: null,
      FileUploadMapLocationsURL: null,
      //
      FileUpload: null,
      FileUploadName: null,
      //
      FileProfile: null,
      FileProfileURL: "https://via.placeholder.com/200?text=CPF",
      //
      TitleSelect: true,
      // BaseURLData: "http://localhost:8085/form/scholarship/",
      // BaseAPIData: "http://localhost:8083/",

      BaseURLData: "https://tica.or.th/uploads/form/scholarship-cpf/",
      BaseAPIData: "https://tica.or.th/uploads/form/scholarship-cpf/images/save/",
    };
  },
  async created() {
    this.RandomID = await sessionStorage.getItem("UID");
  },
  async mounted() {
    sessionStorage.getItem("UID") == null ||
    sessionStorage.getItem("UID") == "null" ||
    sessionStorage.getItem("UID") == ""
      ? (this.RandomID = await this.randID(10))
      : (this.RandomID = await sessionStorage.getItem("UID"));
    await this.setID();
    if (
      sessionStorage.getItem("ScholarshipEdit") == "true" &&
      sessionStorage.getItem("dataI1") != null
    ) {
      const editeData = sessionStorage.getItem("dataI1");
      this.ScholarshipApplicant = JSON.parse(editeData);
      this.FileProfileURL = this.ScholarshipApplicant.Profile.Image;
      this.FileUploadName = this.ScholarshipApplicant.Signature.SignatureImageOldName;
      this.FileUploadMapLocationsURL = this.ScholarshipApplicant.mapLocations;
    } else {
      // this.ScholarshipApplicant.SiblingEducationAndCareer[0] = {
      //   No: 0,
      //   Gender: "ช",
      //   Workplace: "สุขุมวิท",
      //   Education: "ปริญญาตรี",
      //   AverageMonthlyIncome: "15000",
      // };
      // this.ScholarshipApplicant.SiblingEducationAndCareer[1] = {
      //   No: 1,
      //   Gender: "ญ",
      //   Workplace: "ลาดพร้าว",
      //   Education: "ปริญญาตรี",
      //   AverageMonthlyIncome: "18000",
      // };
      // this.ScholarshipApplicant.Profile = {
      //   Title: "นาย",
      //   NameTH: "สมพง",
      //   Email: "a@mail.com",
      //   LastnameTH: "ทรงสิทธ์",
      //   NameEN: "Sompong Throngsit",
      //   Image: "",
      //   StudyingAtTheInstitute: "มหาวิทยาลัยศรีนครินทรวิโรฒ",
      //   Faculty: "วิศวกรรมศาสตร์",
      //   Major: "วิศวกรรมเครื่องกล",
      //   StudentCode: "65010100",
      //   YearClass: "2",
      //   AverageScoreNow: "3.50",
      //   DateOfBirth: "",
      //   PlaceOfBirth: "โรงพยาบาลกรุงเทพ",
      //   Religion: "พุทธ",
      //   Domicile: {
      //     Number: "100",
      //     Moo: "10",
      //     Road: "สุขุมวิท",
      //     Tambon: "สุขุมวิท",
      //     District: "คลองเตย",
      //     Province: "กรุงเทพ",
      //     Postcode: "10110",
      //     Phone: "010-000-0000",
      //     Mobile: "020-000-0000",
      //   },
      //   CurrentAddress: {
      //     Number: "200",
      //     Moo: "10",
      //     Road: "กำาแพงเพชร 2",
      //     Tambon: "จตุจักร",
      //     District: "จตุจักร",
      //     Province: "กรุงเทพมหานคร",
      //     Postcode: "20000",
      //     Phone: "030-000-0000",
      //     Mobile: "040-000-0000",
      //   },
      // };
      // this.ScholarshipApplicant.BriefEducationalBackground = {
      //   PrimarySchool: {
      //     Name: "โรงเรียนรัฐบาล(ประถม)",
      //     Province: "กรุงเทพมหานคร",
      //   },
      //   JuniorHighSchool: {
      //     Name: "โรงเรียนรัฐบาล(มัธยม ต้น)",
      //     Province: "กรุงเทพมหานคร",
      //   },
      //   HighSchool: {
      //     Name: "โรงเรียนรัฐบาล(มัธยม ปลาย)",
      //     Province: "กรุงเทพมหานคร",
      //   },
      //   CumulativeGPA: "3.56",
      // };
      // this.ScholarshipApplicant.FamilyStatusOfTheScholarshipApplicant = {
      //   Father: {
      //     Name: "สมชาย ทรงสิทธ์",
      //     Age: "45",
      //     Alive: 1,
      //     Occupation: "ธุระกิจ",
      //     NatureOfWork: "ธุระกิจส่วนตัว",
      //     Position: "ผู้จัดการ",
      //     MonthlyIncome: "20000",
      //     Workplace: "กรุงเทพมหานคร",
      //     Province: "กรุงเทพมหานคร",
      //     Phone: "050-000-0000",
      //     Mobile: "060-000-0000",
      //   },
      //   Mother: {
      //     Name: "สมศรี ทรงสิทธ์",
      //     Age: "40",
      //     Alive: 1,
      //     Occupation: "ธุระกิจ",
      //     NatureOfWork: "ธุระกิจส่วนตัว",
      //     Position: "รองผู้จัดการ",
      //     MonthlyIncome: "20000",
      //     Workplace: "กรุงเทพมหานคร",
      //     Province: "กรุงเทพมหานคร",
      //     Phone: "070-000-0000",
      //     Mobile: "080-000-0000",
      //   },
      //   Rentinghouse: {
      //     Status: 2,
      //     MonthlyRent: 5000,
      //   },
      //   RelationshipStatus: 0,
      //   Siblings: {
      //     Number: 3,
      //     ChildCurrent: 2,
      //   },
      // };
      // this.ScholarshipApplicant.Patron = {
      //   Name: "-",
      //   Relations: "-",
      //   Number: "-",
      //   Moo: "-",
      //   Road: "-",
      //   Tambon: "-",
      //   District: "-",
      //   Province: "-",
      //   Postcode: "-",
      //   Occupation: "-",
      //   Position: "-",
      //   Workplace: "-",
      //   Phone: "-",
      //   Mobile: "-",
      //   SponsorCount: "-",
      //   Sibling: "-",
      // };
      // this.ScholarshipApplicant.ApplicantDetail.Dormitory = {
      //   status: 4,
      //   Detail: {
      //     name: "หอพัก ดี",
      //     locations: "สุขุมวิท",
      //     room: "301",
      //     mobile: "090-000-0000",
      //     price: "2800",
      //   },
      //   Other: "-",
      // };
      // this.ScholarshipApplicant.IncomeAndExpenses = {
      //   DailyIncome: {
      //     IncomeType: 1,
      //     PerDay: 250,
      //   },
      //   BreakFast: {
      //     Location: 1,
      //     Price: "50",
      //   },
      //   lunch: {
      //     Location: 1,
      //     Price: "50",
      //   },
      //   dinner: {
      //     Location: 0,
      //     Price: "50",
      //   },
      //   ApproximateTravelExpenses: "100",
      //   EducationExpenses: "2100",
      //   OtherExpenses: "800",
      //   EarnExtraMoney: {
      //     Detail: "พนักงานร้านอาหาร",
      //     price: "250",
      //   },
      // };
      // this.ScholarshipApplicant.OtherScholarshipsPreviouslyAwarded = {
      //   ScholarshipsHistoty: 1,
      //   detail: {
      //     Name: "ทุน เอ",
      //     Year: "2564",
      //     Type: {
      //       Name: 1,
      //       Price: "10000",
      //     },
      //   },
      // };
      // this.ScholarshipApplicant.GovernmentScholarships = {
      //   Year: "2563",
      //   Price: "26400",
      // };
      // this.ScholarshipApplicant.SpecialEventsAttended = {
      //   AcademicActivities: "ประกวดภาษาไทย",
      //   PublicInterestActivities: "ค่ายอาสา",
      //   SportsActivities: "ฟุตบอล",
      // };
      // this.ScholarshipApplicant.ProvideAdditionalInformation = {
      //   name: "นายชัยรักษ์ รักดี",
      //   relations: "เพื่อน",
      //   Number: "11",
      //   Road: "สุขุมวิท 12",
      //   Tambon: "คลองเตย",
      //   District: "สุขุมวิท",
      //   Province: "กรุงเทพมหานคร",
      //   Phone: "011-000-0000",
      //   Mobile: "022-000-0000",
      // };
      // this.ScholarshipApplicant.Talent = "พิมพ์ดีดไทย";
      // this.ScholarshipApplicant.HealthProblems = {
      //   CongenitalDisease: {
      //     Status: 0,
      //     Detail: "ภูมิแพ้",
      //   },
      //   OtherProblems: "-",
      //   FamilyProblems: "การเงินไม่เพียงพอ",
      // };
      // this.ScholarshipApplicant.Advisor = "ประสงค์ จงกระเบน";
      // this.ScholarshipApplicant.Signature = {
      //   SignatureImage: null,
      //   SignatureImageOldName: null,
      //   Name: "สมพง ทรงสิทธ์",
      //   Date: "",
      //   Email: "a@mail.com",
      // };
      // this.ScholarshipApplicant.Note = {
      //   PlacesThatCanBeImmediatelySummonedOnCampus: {
      //     Group: "ชมรมกีฬา",
      //     Nuilding: "กิจกรรม",
      //   },
      //   SavingsAccountNumber: {
      //     Name: "สมพง ทรงสิทธ",
      //     AccountNumber: "000-000-000-000",
      //   },
      // };
      // this.ScholarshipApplicant.DescriptionOfFamilyHistory = `(ตัวหนังสือ ทดสอบ) แทงก๊ักอริยสงฆ์เทอร์โบกฤษณ์โจ๋ จตุคามมาร์จินวาริชศาสตร์ ไดเอ็ตอาว์อินดอร์สต๊อก โปรเจ็กเตอร์ มอบตัว
      //   ท็อปบูตเทวาธราช ิ สะบึมดาวน์อันตรกิริยามอบตัว เพนกวิน ครัวซองม้งอิเหนามุมมอง ระโงกซาดิสม์ไฮไลท์ เฮอร์ริเคนว่ะ รีสอร์ต
      //   ดีพาร์ตเมนต์บาร์บี้สวีท เครปง้ีว่ะ เอ๋อ ฮิปโปมิวสิคโอเวอร์
      //   ล็อบบี้ พาสต้าหลวงปู่ สแควร์จัมโบ้ขั้นตอนเทรลเลอร์ ดีพาร์ตเมนท์เซ็นทรัลซาฟารีเฟรช แคนูง้ีด๊ัมพ์เอ๊าะโทร
      //   เยอบีรายาวีพุทธศตวรรษ บัสเซรามิก คอนเซ็ปต์โปรเจ็กเตอร์มุมมองสจ๊วต รีไทร์จิ๊กโก๋ บัตเตอร์เอสเปรสโซไฮไลต์ซิงโบว์ลิ่ง
      //   มหาอุปราชาซาดิสม์วิทย์ พาสต้าซะ แฟ้บโง่เขลา อุปนายกบูมเซอร์วิสสตรอว์เบอร์รี ดราม่าซื่อบื้อซิมโฟนีเฮอร์ริเคน
      //   อวอร์ด อิเลียด เกรย์ วันเวย์ต่อยอดคูลเลอร์เธค พุทธภูมิแซมบ้าเยอร์บีรา วัจนะหลวงพี่ อิมพีเรียล มินท์ดาวน์ไฟแนนซ์
      //   หมายปองแฟนซีสตริงออสซี่ก๊วน สกายสไลด์เยอร์บีราชาร์ตแจ ่ ๊กเก็ต อพาร์ทเมนท์อพาร์ตเมนต์ผลไม้ วาฟเฟิลภควัทคีตายาวี
      //   ไฮแจ็คสเต็ปด๊ัมพ์สไตรค์ไวกิ้ง ฮันนีมูน ฮองเฮานิวดราม่าคอนเทนเนอร์ ธมโม ั
      //   สแล็กอาร์พีจีฮองเฮา โซลาร์วันเวย์ตุ๊ด ฮากกาศากยบุตรออโต้สงบสุข พงษ์เธคตุ๊กมลภาวะต้ืบ อีแต๋น เบอร์รีโบว์ไลฟ์
      //   เบบี้ภควัมปติโมเดิร์นโมเดิร์นยนตรกรรม โต๊ะจีนพงษ์ยาวีสะบึมแบต โทรสึนามิปัจฉิมนิเทศบร็อกโคลี แพทยสภาสโตร์วิลเลจบ๊อกซ์
      //   ก่อนหน้า บู๊พาสตาโหลยโท่ยอุปนายกเทค วอล์คโลชั่นถ่ายทำา บาร์บีคิวแคมป์ชินบัญชรสตรอว์เบอร์รี สเตย์เด้ียงเท่ียงวัน
      //   คอร์ปวิลเลจคอร์ส
      //   โกลด์ แก๊สโซฮอล์ หลวงพี่ดีพาร์ตเมนต์คอรัปชัน ซานตาคลอสรามาธบดิ ี ออโต้แดนเซอร์ อุรังคธาตุโซน่ีเยอร์บีราสเตชันเอาท์
      //   มหาอุปราชา ตุ๊กตุ๊กยากูซาแฟนตาซีด ่ ีพาร์ทเมนท์ แอนด์ เจ๊ียว สารขัณฑ์ว่ะแอคทีฟไนท์เวเฟอร์ รีไทร์คาเฟ่ ไบเบิลโฮลวีต
      //   เหมยวัจนะแมกกาซีน เปเปอร์ไอซ์ แคป
      //   `;
      // this.ScholarshipApplicant.mapLocations = null;
    }
  },
  methods: {
    async setID() {
      await sessionStorage.setItem("UID", this.RandomID);
    },
    randID(length) {
      var result = "";
      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    Submit() {
      if (
        this.FileProfile == null &&
        this.FileProfileURL == "https://via.placeholder.com/200?text=CPF"
      ) {
        alert("กรุณาอัปโหลด รูปโปรไฟล์");
        document.getElementById("profile").scrollIntoView();
      } else if (this.FileUpload == null && this.FileUploadName == null) {
        alert("กรุณาอัปโหลด ลายเซ็น");
        document.getElementById("Signature").scrollIntoView();
      } else if (
        this.FileMapLocations == null &&
        this.FileUploadMapLocationsURL == null
      ) {
        alert("กรุณาอัปโหลด แผนที่บ้าน");
        document.getElementById("HomeMap").scrollIntoView();
      } else {
        this.previewMode = !this.previewMode;
        window.scrollTo(0, 0);
      }
    },
    DateStyleText() {
      this.ScholarshipApplicant.Profile.Title == ""
        ? (this.TitleSelect = true)
        : (this.TitleSelect = false);
    },
    addFamily() {
      this.ScholarshipApplicant.SiblingEducationAndCareer.push({
        No: this.ScholarshipApplicant.SiblingEducationAndCareer.length,
        Gender: "",
        Workplace: "",
        Education: "",
        AverageMonthlyIncome: "",
      });
    },
    removeFamily() {
      this.ScholarshipApplicant.SiblingEducationAndCareer.splice(
        this.ScholarshipApplicant.SiblingEducationAndCareer.length - 1,
        1
      );
    },
    FileSignature(evt) {
      evt.preventDefault();
      this.FileUpload = evt.target.files[0];
      this.FileUploadName = evt.target.files[0].name;
    },
    FileMap(evt) {
      evt.preventDefault();
      this.FileMapLocations = evt.target.files[0];
      this.FileUploadMapLocationsURL = URL.createObjectURL(this.FileMapLocations);
    },
    FileUploadProfile(evt) {
      evt.preventDefault();
      this.FileProfile = evt.target.files[0];
      this.FileProfileURL = URL.createObjectURL(this.FileProfile);
    },
    async SubmitFormData() {
      // Upload file
      if (
        sessionStorage.getItem("ScholarshipEdit") == "true" &&
        sessionStorage.getItem("dataI1") != null
      ) {
        if (this.FileUpload != null) {
          this.ScholarshipApplicant.Signature.SignatureImage = await this.UploadFile(
            this.FileUpload,
            "signature",
            "studentSignature"
          );
        }
        if (this.FileMapLocations != null) {
          this.ScholarshipApplicant.mapLocations = await this.UploadFile(
            this.FileMapLocations,
            "profile",
            "Map"
          );
        }
        if (this.FileProfile != null) {
          this.ScholarshipApplicant.Profile.Image = await this.UploadFile(
            this.FileProfile,
            "profile",
            "Profile"
          );
          this.ScholarshipApplicant.Signature.SignatureImageOldName = this.FileUploadName;
        }
      } else {
        this.ScholarshipApplicant.Signature.SignatureImage = await this.UploadFile(
          this.FileUpload,
          "signature",
          "studentSignature"
        );
        this.ScholarshipApplicant.mapLocations = await this.UploadFile(
          this.FileMapLocations,
          "profile",
          "Map"
        );
        this.ScholarshipApplicant.Profile.Image = await this.UploadFile(
          this.FileProfile,
          "profile",
          "Profile"
        );
        this.ScholarshipApplicant.Signature.SignatureImageOldName = this.FileUploadName;
      }
      // set session
      await this.SetSession();
      // call func paren page
      await this.$emit("ScholarshipFunc");
    },
    async UploadFile(fileData, folder, Name) {
      var FileName = "";
      const UID = this.RandomID;
      const BaseURLData = this.BaseURLData;
      const BaseAPIData = this.BaseAPIData;
      const data = new FormData();
      data.append("fileUpload", fileData);
      data.append("fileName", Name);
      data.append("target", UID);
      data.append("subtarget", folder);
      const url = `${BaseAPIData}uploadFile.php`;
      const header = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      await axios.post(url, data, header).then(function (response) {
        FileName = `${BaseURLData}images/save/assets/img/${UID}/${folder}/${response.data.response}.${response.data.type}`;
      });
      return FileName;
    },
    async SetSession() {
      await sessionStorage.setItem("dataI1", JSON.stringify(this.ScholarshipApplicant));
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100% !important;
}
.bg_dark_blue {
  background-color: #102f50 !important;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.home {
  background-color: #3c3c3b !important;
  font-family: Georgia, Times, serif !important;
}
input[type="file"] {
  display: none !important;
}
.custom-file-upload {
  border: 1px solid #ccc !important;
  display: inline;
  padding: 5px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}

.custom-exam-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 5px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}
.text-truncate {
  white-space: nowrap !important;
  padding-right: 5rem !important;
  padding-left: 1rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.w-45 {
  width: 45%;
}
.other-btn {
  padding: 6px 25px !important;
}
.text-sec {
  color: #6c757d !important;
}
</style>
<style>
.multiselect__option--highlight {
  background: #102f51 !important;
  outline: none !important;
  color: #fff !important;
}
.multiselect__option--highlight:after {
  background: #102f51 !important;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #102f51;
  margin-bottom: 0;
}
.multiselect__tags {
  min-height: 25px;
  padding: 2px 40px 0 8px;
  border-color: black;
}
.multiselect__tag-icon:after {
  color: white;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #102f51 !important;
}
.req {
  border-color: red !important;
}

.img-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
